import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { clamp } from 'utils/math';

import SelectableSection from 'components/editor/selectableSection';
import Play from 'components/icons/playButton';
import Pause from 'components/icons/pauseButton';

import s from 'components/editor/pages/landing/promoTouts/promoTouts.sss';

export default class PromoTouts extends Component {
	constructor(props) {
		super(props);

		this.slides = [];
		this.intervalDuration = 5000;
		this.perSlide = 2;
		this.state = {
			slideIndex: 0,
			isPlaying: true,
		};
		this.timerRef = null;

		this.next = this.next.bind(this);
		this.togglePlay = this.togglePlay.bind(this);
		this.renderTout = this.renderTout.bind(this);
	}

	componentDidMount() {
		this.autoplayIfNeeded();
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	componentWillReceiveProps(nextProps) {
		// Make sure we're not outside the valid range
		const newSlideIndex = clamp(this.state.slideIndex, 0, this.getSlidesCount(nextProps) - 1);
		if (newSlideIndex !== this.state.slideIndex) {
			this.setState({ slideIndex: newSlideIndex });
		}

		if (nextProps.activeElement?.startsWith(nextProps.basePath)) {
			const id = nextProps.activeElement.split('/').pop();
			const itemIndex = this.getItems(nextProps).findIndex(item => item.id === id);
			if (itemIndex !== -1) {
				this.goToSlide(Math.floor(itemIndex / this.perSlide), nextProps);
			}
			this.autoplayIfNeeded(nextProps);
		} else if (this.props.activeElement?.startsWith(this.props.basePath)) {
			// No longer active: restart autoplay if needed
			this.autoplayIfNeeded(nextProps);
		}
	}

	getItems(props = this.props) {
		return props.items?.filter(e => e?.image) || [];
	}
	getSlidesCount(props = this.props) {
		return Math.ceil(this.getItems(props).length / this.perSlide);
	}

	shouldAutoplay(props = this.props) {
		return this.getItems(props).length > this.perSlide && !props.activeElement?.startsWith(props.basePath);
	}

	autoplayIfNeeded(props = this.props) {
		clearTimeout(this.timer);

		if (!this.shouldAutoplay(props) || !this.state.isPlaying) {
			return;
		}

		this.timer = setTimeout(this.next, this.intervalDuration);
	}

	next() {
		this.goToRelativeSlide(1);
	}

	goToSlide(index, props = this.props) {
		if (this.state.slideIndex === index) return;
		clearTimeout(this.timer);
		this.setState({ slideIndex: index });
		this.autoplayIfNeeded(props);
	}

	goToRelativeSlide(step) {
		this.goToSlide(
			(this.state.slideIndex + step) % this.getSlidesCount()
		);
	}

	togglePlay() {
		clearTimeout(this.timer);
		const isPlaying = !this.state.isPlaying;
		this.setState({ isPlaying });
		this.autoplayIfNeeded();
	}

	renderTout(tout) {
		return (
			<SelectableSection {...this.props} section={`${this.props.basePath}/list/${tout.id}`} class={s.posterWrapper} key={tout.id}>
				<img class={s.poster} src={tout.image} alt={tout.alt || `${tout.title || 'Tout'} image`} width="800" height="500" />
			</SelectableSection>
		);
	}

	renderSlide(group, index) {
		const key = group.map(e => e.id).join('|');
		return (
			<div class={joinClasses(s.slide, this.state.slideIndex === index && s.active)} key={key}>
				{group.map(this.renderTout)}
			</div>
		);
	}

	render() {
		const { slideIndex, isPlaying } = this.state;

		const slidesCount = this.getSlidesCount();

		const shouldAutoplay = this.shouldAutoplay();

		const items = this.getItems();
		const slides = [];
		for (let i = 0; i < slidesCount; i++) {
			const from = i * this.perSlide;
			slides.push(this.renderSlide(items.slice(from, from + this.perSlide), i));
		}

		return (
			<div class={s.wrapper}>
				<div class={s.slidesWrapper}>
					{slides}
				</div>
				<div class={joinClasses(s.controls, slidesCount <= 1 && s.hidden)}>
					<div class={s.pages}>
						{slides.map((_, i) => <button class={i === slideIndex && s.active} onClick={() => this.goToSlide(i)} data-section="#" />)}
					</div>
					<button class={s.play} onClick={this.togglePlay} disabled={!shouldAutoplay} data-section="#">
						{shouldAutoplay && isPlaying ? <Pause height="14" /> : <Play height="14" />}
					</button>
				</div>
			</div>
		);
	}
}
